import { QuestionBodyPartnerInterest } from '@/features/advisor-onboarding/questionnaire/components/question-body-partner-interest';
import { QuestionScreenLayout } from '@/features/advisor-onboarding/questionnaire/components/question-screen-layout';

import { useQuestionScreen } from '@/features/advisor-onboarding/questionnaire/contexts/question-screen-context';
import { usePartnerInterestQuestion } from '@/features/advisor-onboarding/questionnaire/hooks/use-partner-interest-question';

import type { BgaPartnerInterest } from '@shared';

export function PartnerInterestScreen() {
  const { resolved, answers, isSubmitting, submitAnswerWithoutAdvance, advance } =
    useQuestionScreen();

  const initialValue = (answers.bga_partner_interest as BgaPartnerInterest | undefined) ?? null;

  const { value, confirmedValue, select, confirm } = usePartnerInterestQuestion({
    initialValue,
    submitWithoutAdvance: submitAnswerWithoutAdvance,
    advance,
  });

  return (
    <QuestionScreenLayout
      showNext={!!confirmedValue}
      nextLabel="Continue"
      onNext={confirm}
    >
      <QuestionBodyPartnerInterest
        options={resolved.options}
        value={value}
        confirmedValue={confirmedValue}
        onSelect={select}
        disabled={isSubmitting}
      />
    </QuestionScreenLayout>
  );
}
